__turbopack_context__.v({
  "tooltip": "TooltipContent-module-sass-module__GoOXla__tooltip",
  "wrapper": "TooltipContent-module-sass-module__GoOXla__wrapper",
});
